<template>
  <section v-if="!isPageLoading" class="sonar">
    <div class="sonar__container">
      <div class="sonar__header sonar__header--share">
        <img
          src="../assets/images/sonar-logo.png"
          alt="Sonar logo"
          class="sonar__header-logo"
        />
        <h3 class="sonar__header-sub-title sonar__header-sub-title--share">
          {{ scoreCardLabel }}
        </h3>
      </div>
      <SonarOverviewCard
        class="sonar__overview-card"
        :currentScore="currentScore"
        :isSharingResults="true"
        :userHasStats="false"
      />
    </div>
  </section>
  <div v-else class="sonar__loader-wrapper">
    <ActionLoader />
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import SonarOverviewCard from '@/sonar/components/SonarOverviewCard.vue'
import ActionLoader from '@/components/shared/ActionLoader.vue'

export default {
  name: 'SonarShare',
  components: {
    SonarOverviewCard,
    ActionLoader,
  },
  data() {
    return {
      sharedScore: {},
      currentScore: {},
    }
  },
  computed: {
    ...mapState({
      isPageLoading: state => state.app.isPageLoading,
    }),
    ...mapGetters({
      assessments: 'sonar/assessments',
    }),
    scoreCardLabel() {
      return `${this.currentScore?.user_name}'s scorecard`
    },
  },
  async created() {
    const score_id = this.$route.query.id
    if (!score_id) this.$router.push({ name: 'home' })
    this.currentScore = await this.$store.dispatch(
      'sonar/getSharedScore',
      score_id
    )
    if (!this.currentScore) this.$router.push({ name: 'home' })
    this.$store.dispatch('app/setIsPageLoading', false)
  },
}
</script>
